import { FC, memo } from 'react';
import { TokenLogo, LogoProps, LogoMap, DEFAULT_LOGO_MAP } from '@tempusfinance/common-ui';
import { LogoType } from './LogoType';
import { NostraLogo } from './NostraLogo';
import { NostraFullLogo } from './NostraFullLogo';
import { StarknetLogo } from './Starknet';
import { NostraSwapLogo } from './NostraSwapLogo';
import { AvnuSwapLogo } from './AvnuSwapLogo';
import { TokenZUSDC } from './TokenZUSDC';
import { ArgentLogo } from './WalletArgentLogo';
import { WalletBraavosLogo } from './WalletBraavosLogo';
import { AirdropLogo } from './AirdropLogo';
import { LayerswapLogo } from './LayerswapLogo';
import { NostraFullLogoDark } from './NostraFullLogoDark';

const ICON_MAP: LogoMap = {
  ...DEFAULT_LOGO_MAP,
  'nostra-logo': NostraLogo,
  'nostra-full-logo': NostraFullLogo,
  'starknet-logo': StarknetLogo,
  'nostra-swap-logo': NostraSwapLogo,
  'avnu-swap-logo': AvnuSwapLogo,
  'token-zUSDC': TokenZUSDC,
  'token-USDC.e': DEFAULT_LOGO_MAP['token-USDC'],
  'wallet-argent': ArgentLogo,
  'wallet-braavos': WalletBraavosLogo,
  'airdrop-logo': AirdropLogo,
  'layerswap-logo': LayerswapLogo,
  'nostra-full-logo-dark': NostraFullLogoDark,
};

const LogoComponent: FC<LogoProps & { type: LogoType }> = props => (
  <TokenLogo<LogoType> {...props} logoMap={ICON_MAP} />
);

export const Logo = memo(LogoComponent);
